export const environment = {

  // this is overwritten in the CI
  apiUrl: 'https://renovate-marked-18-x.api.coronavis.dbvis.de/',

  // this is overwritten in the CI
  tileServerUrl: 'https://staging.tiles.coronavis.dbvis.de/',

  version: 'f164d090',

  env: 'review',

  dsn: 'https://6ff2c8f17a534f83bcf18385529d1f59@sentry.io/5185839'
};
